import { HelpMenu } from '../help-menu/HelpMenu'
import { AppsMenu } from '../apps-menu/AppsMenu'
import { UserData } from '../user-profile/UserProfile'

const RightNav = [{ ...HelpMenu }, { ...AppsMenu }, { ...UserData }]
export { RightNav }
